import Vue from "vue";

Vue.directive('open-mobile-navigation', {

    bind(el, binding) {
        el.onclick = function(event) {

            document.querySelector('.mobile-navigation').classList.add('mobile-navigation--open');
            document.querySelector('body').classList.add('mobile-navigation--visible');

            $('.basket-preview').removeClass('basket-preview--open');
            $('body').removeClass('basket-preview--visible');
            $('.shop-nav__btn-basket-preview').removeClass('shop-nav__btn--close');

        };
    },
});
